document.addEventListener('DOMContentLoaded', function(){
	setAwardsWork();
});

const setAwardsWork =()=>{
	const wrks=document.querySelectorAll(".awardsWorks ul");
	wrks.forEach((w)=>{
		const len=w.childElementCount;
		if(len<=2){
			w.classList.add("wid-Content");
		}else if(len==4){
			w.classList.add("wid-Content");
		}else{
			w.classList.add("wid-Inner");
		}
		
		
	});
}